import React, { Component } from 'react';

class BantCurrencyValue extends Component {

    
    state = { 
        value : this.props.value,
        currency : this.props.currency,
        id : this.props.id
     }

    componentDidUpdate(prevProps) {
  
    if (this.props.value !== prevProps.value) 
    {
        const tdid = this.props.id;

        var element = document.getElementById(tdid);
        if(element !== null){
            if(this.props.value < prevProps.value)
            {
                element.style.color = "red";
            }
            else if(this.props.value > prevProps.value)
            {
                element.style.color = "green";
            }

            setTimeout( function(){
                const item = document.getElementById(tdid);
                if (item != null)
                    item.style.color = "white";
            },1000);
        }

        this.setState({value : this.props.value});

    }   
    }

    render() { 
        return <td id={this.state.id}><div className="bantCurrencyValue">{this.state.value.toLocaleString('tr-TR')} {this.state.currency}</div></td>;
    }
}
 
export default BantCurrencyValue;